define('app/visualizations/MonitorGridView',['require','glu/layout','glu/collection','glu/util','glu/grid/gridLayout','glu/itemView','glu/grid/column/columnHeader','hbs!./GridHeaderView.hbs','hbs!./MonitorGridView.hbs'],function(require) {
	'use strict';

	var Layout = require('glu/layout'),
		Collection = require('glu/collection'),
		_ = require('glu/util'),
		Grid = require('glu/grid/gridLayout'),
		ItemView = require('glu/itemView'),
		ColumnHeader = require('glu/grid/column/columnHeader'),
		GridHeaderView = require('hbs!./GridHeaderView.hbs'),
		tmpl = require('hbs!./MonitorGridView.hbs');

	return Layout.extend({
		template: tmpl,

		regions: {
			monitorGridView: '#monitor-grid-view'
		},

		initialize: function() {
			var self = this;

			this.HeaderView = ColumnHeader.extend({
				initialize: function() {
					if (this.model.id === 'SEGMENTS') {
						this.model.set('columnTypeClass', ' segment');
					} else {
						this.model.set('columnTypeClass', ' metric');
					}

					this.listenTo(this, 'reorder', function() {
						self.model.trigger('monitor:change', self.updateColumnOrder());
					});
				},

				getTemplate: function() {
					return GridHeaderView;
				}
			});

			this.DetailsCellView = ItemView.extend({
				tagName: 'td',
				serializeData: function() {
					return this;
				},
				value: function() {
					var column = this.options.column;
					var format = column.get('format') || _.identity;
					return format(this.model.escape(column.get('field')));
				},
				template: function(view) {
					return '&nbsp;' + view.value();
				},
				className: function() {
					return this.options.column.get('className');
				}
			});

			this.columns = new Collection();
			this.collection = new Collection();
		},

		activate: function() {
			var self = this;
			self.attachListeners();

			if (this.isRendered) {
				self.refreshResults();
				self.$el.removeClass('is-loading');
				self.$el.find('.loading-indicator').remove();
			}
		},

		onRender: function() {
			this.isRendered = true;
		},

		onShow: function() {
			this.activate();
		},

		onClose: function() {
			this.collection.reset();
		},

		attachListeners: function() {
			var self = this;
			var monitor = this.model;

			self.listenTo(this.model, 'monitor:dataReceived', function() {
				self.refreshResults();
				self.$el.removeClass('is-loading');
				self.$el.find('.loading-indicator').remove();
			});

			window.setTimeout(function() {
				self.listenTo(self.columns, 'change:width', function() {
					self.columns.each(function(column, index) {
						if (self.isInitalizingWidths) {
							return;
						}
						monitor.setOption('columnWidth:' + index, column.get('width'));
						monitor.trigger('monitor:change');
					});
				});
			}, 1000);


			window.setTimeout(function() {
				self.listenTo(self.columns, 'change:sorted', function(column, direction) {
					var index = column.collection.indexOf(column);
					monitor.getResults().sort(index, direction);
					monitor.trigger('monitor:change');
				});
			}, 1000);

			// display a loading indicator whenever a report is run
			self.listenTo(monitor, 'run', function() {
				self.$el.addClass('is-loading');

				// ensure self icon is only displayed once
				if (!self.$el.find('.loading-indicator').length) {
					self.$el.append('<div class="loading-indicator">Loading&hellip;</div>');
				}
			});
		},

		updateColumnOrder: function() {
			var self = this;
			var i = 0;

			for (i = 0; i < self.columns.models.length; i++) {
				// do not touch Segments column
				var columnId = self.columns.models[i].get('metadata').id;
				if (columnId === 'SEGMENTS') {
					continue;
				}

				var index = this.model.getMetrics().indexOf(columnId);
				if (index > -1) {
					this.model.getMetrics().splice(index, 1);
					this.model.getMetrics().push(columnId);
				}
			}
		},

		refreshResults: function() {
			var monitor = this.model;
			var gridResults = monitor.getResults();
			var self = this;


			if (gridResults) {
				self.columns.reset(gridResults.columns());
				self.collection.reset(gridResults.rows());

				if (monitor.attributes.options) {
					var monitorOptions = JSON.parse(JSON.stringify(monitor.attributes.options));
					self.columns.each(function(column, i) {
						var width = monitorOptions['columnWidth:' + i];
						if (width) {
							column.set('width', width);
						}
					});
				}

				self.columns.last().set('width', 'auto');

				self.columns.each(function(column) {
					column.set('cellView', self.DetailsCellView);
					column.set('headerView', self.HeaderView);
				});

				if (self.isRendered && this.monitorGridView) {

					var grid = new Grid({
						filter: false,
						paginate: false,
						pageSize: 50,
						defaultColumnWidth: 'auto',
						collection: this.collection,
						columns: this.columns,
						resizable: true,
						disableDynamicColumnWidths: true,
						stickyFooter: true,
						defaultSort: gridResults.getSort()
					});

					this.monitorGridView.show(grid);
					monitor.trigger('gridRendered');
				}
			}
		}

	});

});

